// UUID v1-v5 validation regex (case-insensitive):
// Matches strings in the format: xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx
// Where:
// - Each 'x' is a hexadecimal digit [0-9a-f]
// - 'M' is the UUID version (1 to 5)
// - 'N' is the UUID variant (8, 9, a, or b)
//
// Breakdown:
// ^                         → Start of string
// [0-9a-f]{8}               → 8 hex digits
// -                         → Hyphen
// [0-9a-f]{4}               → 4 hex digits
// -                         → Hyphen
// [1-5][0-9a-f]{3}          → Version: 1-5 followed by 3 hex digits
// -                         → Hyphen
// [89ab][0-9a-f]{3}         → Variant: one of 8, 9, a, or b followed by 3 hex digits
// -                         → Hyphen
// [0-9a-f]{12}              → 12 hex digits
// $                         → End of string
// /i                        → Case-insensitive flag (matches A-F as well)
//
// Example match: f47ac10b-58cc-4372-a567-0e02b2c3d479

export const uuidPattern = new RegExp(
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i
);

/**
 * Regular expression to validate a U.S. Employer Identification Number (EIN).
 *
 * Valid format:
 * - Nine digits in total, with or without a hyphen (e.g., "12-3456789" or "123456789")
 * - The first two digits (prefix) must be a valid IRS-assigned range:
 *   01–06, 10–16, 20–27, 30–59, 60–68, 71–77, 90–95, or 98–99
 *
 * This regex ensures the EIN has the correct structure and prefix.
 */
export const EINCheck = /^\d{2}-?\d{7}$/;

/**
 * Regular expression to validate a basic website URL format.
 *
 * Supports:
 * - Optional protocol (http or https)
 * - Optional "www." prefix
 * - Domain name with 1–3 dot-separated segments (e.g., example.com, example.co.uk)
 * - Optional path (e.g., /page, /page/section)
 * - Optional query parameters (e.g., ?key=value&another=value)
 *
 * Examples of valid matches:
 * - "https://www.example.com"
 * - "http://example.co.uk/page"
 * - "www.example.com?key=value"
 * - "example.com"
 *
 *  Note: This is a lightweight regex for general use. It does **not fully validate** all RFC-compliant URLs or handle edge cases like IPv6 hosts, ports, or authentication headers.
 */
export const WebsiteURLCheck = /((https?):\/\/)?(www\.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/;
